import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ApplicationStore } from '@core/stores/application.store';
import { CheckboxComponent } from '@shared/components/form/input/checkbox.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentCardComponent } from '@shared/components/common/component-card/component-card.component';

@Component({
  selector: 'app-user-info-card',
  imports: [
    CheckboxComponent,
    TranslatePipe,
    ComponentCardComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './user-info-card.component.html',
})
export class UserInfoCardComponent {
  readonly applicationStore = inject(ApplicationStore);

}
